import React from 'react';
import { Image } from 'components/atoms/image';
import './styles.scss';

const OverlayNewsCard = props => {
  const { data } = props;
  return (
    <div className={'overlay-news-card-body'}>
      <div className={'image-container'}>
        <Image
          src={data.picture}
          isHoveredImagePresent={true}
          alt="News-Publication"
          thumbNail={data.media_path_thumbnail}
        />
      </div>
      <div className={'details-container'}>
        <span className={'published-date'}>{data.published_on}</span>
        <div className={'description-container'}>
          <h2 className={'title'}>{data.title}</h2>
          <p className={'description'}>{data.description}</p>
        </div>
        {data.pdf_path && (
          <span
            className={'read-more'}
            onClick={() => window.open(data.pdf_path)}
          >
            READ MORE
          </span>
        )}
      </div>
    </div>
  );
};
export default OverlayNewsCard;
